import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MatFormFieldControlBase } from '@fi-shared/widget/mat-form-field-control-base';
import { ICheckpointActionSettings } from '@fi-shared/checklist/checklist-v2';
import { FiCheckpointActionTimePeriodTypeOptions } from '@fi-shared/checklist/checklist-consts';
import { Animations } from '@fi-shared/utils/animations';

@Component({
    selector: 'fi-checkpoint-action-task-deadline',
    templateUrl: './action-task-deadline.component.html',
    styleUrls: ['./action-task-deadline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-action-task-deadline' },
    standalone: false,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: FiCheckpointActionTaskDeadlineComponent,
        },
    ],
    animations: [Animations.fadeHeight()],
})
export class FiCheckpointActionTaskDeadlineComponent extends MatFormFieldControlBase<ICheckpointActionSettings> {
    protected readonly FiCheckpointActionTimePeriodTypeOptions = FiCheckpointActionTimePeriodTypeOptions;

    protected handleDeadlinValueBlur(): void {
        if (!this.ngModel.TaskDeadlineValue) {
            this.ngModel.TaskDeadlineValue = 1;
            this.doPropagateChanges();
        }
    }
}
